const Heading = {
  baseStyle: {},
  variants: {
    label: {
      color: 'whiteAlpha.700',
      fontFamily: 'heading',
      fontSize: 'xs',
      textTransform: 'uppercase',
      letterSpacing: '0.15em',
      marginTop: 0,
      lineHeight: 'xs',
    },
    value: {
      color: 'whiteAlpha.900',
      fontWeight: '400',
      fontFamily: 'mono',
      fontSize: 'xl',
    },
  },
  sizes: {},
  defaultProps: {},
};

export default Heading;
